/** Common Components */
import MolGrid, { Column } from "@moltech/molui/molgrid";
import { useEffect, useRef, useState } from "react";
import { useGetContractConsumptionDetailMutation } from "../../../../../../../app/services/contractAPI";

const ConsumptionDetail = (props) => {
  const gridRef = useRef();
  const contractId = props.contractId;
  const repairKey = props.rowData.lRepairKey;
  const [gridData, setGridData] = useState([]);

  const [getAllContractConsumptionList, {
    isSuccess: isAllContractConsumptionFetched,
    data: AllContractConsumptionData
  }] = useGetContractConsumptionDetailMutation();

  useEffect(() => {
    const request = {
      plContractKey: contractId,
      plRepairKey: repairKey,
    }
    getAllContractConsumptionList(request);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractId]);

  useEffect(() => {
    if (isAllContractConsumptionFetched && AllContractConsumptionData) {
      setGridData(AllContractConsumptionData);
    }
  }, [isAllContractConsumptionFetched, AllContractConsumptionData]);

  const totalAmount = gridData?.reduce(
    (sum, item) => sum + (item.amount || 0),
    0
  );


  return (
    <>
      <div className="row gap-4">
        <div className="scrollable-grid col-12 consumption-detail-model">
          <MolGrid
            ref={gridRef}
            value={gridData}
            grouping
            expandableRowGroups={true}
            paginator={false}
            scrollable
            scrollHeight="flex"
            filterDisplay="row"
            sortMode="single"
            showGridlines
            resizableColumns
          >
            <Column
              field="sItemDescription"
              header="Repair Item"
              grouping
              sortable
            />
            <Column
              field="amount"
              header="Consumption Amount"
              body={(rowData) => `$${rowData.amount?.toFixed(2)}`}
              footer={`$${totalAmount.toFixed(2)}`}
              grouping
              sortable
            />

          </MolGrid>
        </div>
      </div>
    </>
  );
};
export default ConsumptionDetail;
